import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ErrorBoundary from "../../../Error/widgets/ErrorBoundary";
import MessageError from "../../../Error/screens/MessageError";

import SkeletonBookmarks from "../../components/BookmarkResult/skeleton";

import BookmarksResult from "../../components/BookmarkResult";


import translate from '../../../../modules/translate'
const Wrapper = styled.div``

const errorOptions = {
  component: translate('bookmark_error'),
  link: '/',
  linkText: translate('error_try_homepage'),
  logError: 'Bookmark screen display',
}


const BookmarkScreen = ({ response: { data,meta },title, run, error, loading, ready, ...props }) => (
  <ErrorBoundary {...errorOptions} {...props}>
    {error && <MessageError logInfo={error.message} {...errorOptions} />}
    {loading && <SkeletonBookmarks meta={meta} /> }
    {data && <BookmarksResult data={data} meta={meta} run={run}/> }
  </ErrorBoundary>
)
BookmarkScreen.propTypes = {}
BookmarkScreen.defaultProps = {}
export default BookmarkScreen
